/*@ngInject*/
module.exports = function publicObjectsService($http) {

    this.TYPE_OBJECT = 'OBJECT';
    this.TYPE_ROAD_ELEMENT = 'ROAD ELEMENT';
    this.TYPE_ROUTE = 'ROUTE';

    this.getTopObjects = function() {
        return $http.post('objects/getTopObjects/');
    };

    this.getObjectDataById = function(objectId) {
        return $http.get('objects/getObjectDataById/' + objectId);
    };
    this.getObjectDataByGisId = function(gisId) {
        return $http.get('objects/getObjectDataByGisId/' + gisId);
    };

    this.getObjectComponents = function(versionId) {
        return $http.get('objects/getObjectComponents/' + versionId);
    };

    this.getPublishedObjectsGisIds = function () {
      return $http.get('objects/getPublishedObjectsGisIds');
    };

    this.getWelcomeText = function(name) {
        return $http.get('objects/getWelcomeText/' + name);
    };

    this.getObjectsBySearch = function(filter, search) {
        return $http.post('objects/getObjectsBySearch/', {filter, search});
    };

    this.getMapObjectsBySearch = function(filter, search) {
        return $http.post('objects/getMapObjectsBySearch/', {filter, search});
    };
    
    this.getPublicTransportStopObjects = function() {
        return $http.get('objects/getPublicTransportStopObjects/');
    };

    this.getParkingObjects = function() {
        return $http.get('objects/getParkingObjects/');
    };

    this.objectsAmountForCategories = function(filter) {
        return $http.post('objects/objectsAmountForCategories/', {filter});
    };

    this.addComment = function(objectData) {
        return $http.post('objects/addComment', objectData);
    };

    this.addSuggestion = function (suggestion, id, objectType) {
        return $http.post('objects/addSuggestion', {suggestion, id, objectType});
    };

    this.getForPublicEditByObjectId = function(objectId, status) {
        return $http.get('objects/getForPublicEditByObjectId/' + objectId + '/' + status);
    };

    this.saveObject = function(object) {
        return $http.post('objects/saveObject', object);
    };

    this.getObjectClassifiers = function() {
        return $http.get('objects/getObjectClassifiers');
    };


    this.uploadImageFile = function(data) {
        return $http.post('objects/uploadImage', data, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        });
    };

    this.getSurveysByComponent = function (componentId) {
        return $http.get('objects/getSurveysByComponent/' + componentId);
    };

    this.saveComponentSurvey = function(surveysData) {
        return $http.post('objects/saveComponentSurvey', {surveysData});
    };

    this.saveSurveyAnswer = function(data) {
        return $http.post('objects/saveSurveyAnswer',  data, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        });
    };

    this.saveEditedImageData = function(imageData) {
        return $http.post('objects/saveEditedImageData', {imageData});
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/services/public-objects.service.js
 **/